module.exports = __webpack_public_path__ + "static/media/image3.5a8b389f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Coinbase/image3.jpg
// module id = 1049
// module chunks = 0